<app-wheel-history class="container wheel__bets"></app-wheel-history>
<div class="grid-container container wheel__main">
  <app-wheel-bet-section></app-wheel-bet-section>
  <app-wheel-main></app-wheel-main>
</div>
<div class="container wheel__colors box-black-third rounded-6">
  <app-wheel-color-row [color]="'gray'"></app-wheel-color-row>
  <app-wheel-color-row [color]="'red'"></app-wheel-color-row>
  <app-wheel-color-row [color]="'blue'"></app-wheel-color-row>
  <app-wheel-color-row [color]="'gold'"></app-wheel-color-row>
</div>
